import React from "react";
import { ColorCardBGLight } from "../Config";

function HowToHumanize() {
  return (
    <div
      className="container justify-content-center text-center"
      style={{ marginTop: "7rem" }}
    >
      {/* How to humanize heading */}
      <h1 className="d-inline display-6">How to humanize</h1>
      <label className="ms-2 fs-5">AI written texts?</label>

      {/* How to humanize text grid*/}
      <div className="row mt-5 justify-content-center">
        <div
          className="card col-lg-4 m-2 shadow rounded-pill"
          style={{ backgroundColor: ColorCardBGLight }}
        >
          <div className="card-body">
            <h2 className="card-title text-danger">1</h2>
            <h6 className="card-subtitle mb-2 text-success">
              Copy AI-generated Texts
            </h6>
            <p className="card-text text-muted">
              HumanizeTexts works with text from ChatGPT, Claude, Deepseek,
              Gemini, or any other AI text generator.
            </p>
          </div>
        </div>

        <div
          className="card col-lg-3 m-2 shadow rounded-pill"
          style={{ backgroundColor: ColorCardBGLight }}
        >
          <div className="card-body">
            <h2 className="card-title text-danger">2</h2>
            <h6 className="card-subtitle mb-2 text-success">
              Paste into HumanizeTexts.com
            </h6>
            <p className="card-text text-muted">
              Our advanced AI text converter will process the text and convert
              it into a more human-like version.
            </p>
          </div>
        </div>

        <div
          className="card col-lg-4 m-2 shadow rounded-pill"
          style={{ backgroundColor: ColorCardBGLight }}
        >
          <div className="card-body">
            <h2 className="card-title text-danger">3</h2>
            <h6 className="card-subtitle mb-2 text-success">
              Click on "Humanize Text"
            </h6>
            <p className="card-text text-muted">
              You can change each word, sentence, or paragraph individually to
              make it more human-like from the provided options.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HowToHumanize;
